export const eventsFilters = {
  category: {
    CREDIT_ANALYSIS: 'Credit Analysis',
    ESG_ANALYSIS: 'ESG Analysis',
    FUNDS_ANALYSIS: 'Funds Analysis',
  },
  timeline: {
    upcoming: 'Upcoming events',
    past: 'Past events',
  },
  favourites: 'Favorites',
};
